import { Button } from 'primereact/button';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import emptyIllustration from '../../../../../../../assets/svg/no-data-pana.svg';
import { FormValues } from '../../CreateEditDialog.functions';
import styles from './Discounts.module.scss';

function EmptyContent(): JSX.Element {
  const { t } = useTranslation();
  const { setValue } = useFormContext<FormValues>();

  return (
    <div className={styles.emptyContent}>
      <img src={emptyIllustration} alt="" className="illustration" />
      <p>
        {t('No discounts are present yet.')}
        <br />
        {t('Add the first one by clicking the button below!')}
      </p>

      <Button
        type="button"
        label={t('Add discount')}
        icon="fas fa-plus"
        onClick={() =>
          setValue('popust', [
            {
              UslugaId: 0,
              ProizvodId: 0,
              StatusId: 0,
              Popust: '',
            },
          ])
        }
        className="p-button-outlined"
      />
    </div>
  );
}

export default EmptyContent;
